import React, { Component } from 'react';
import SCurrencyDisplay from 'shared/components/CurrencyDisplay';
import { TYPEOF } from 'shared/constants';
import generateRender from 'shared/utils/generateRender';
import { ThemeContext } from 'styled-components';
import Bar from '../Bar/Bar';
import ImageBW from '../ImageBoundsWrapper';
import Tooltip from '../Tooltip';
import { CoinsGlowAnimation, CurrencyImageWrapper } from './styledComponents';

export const currencyDisplayComponentName = 'CurrencyDisplay';

export default class CurrencyDisplay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value,
      shouldAnimate: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value && this.state.shouldAnimate) {
      this.setState({ value: this.props.value });
    } else if (prevProps.value !== this.props.value) {
      this.setState({ value: this.props.value });
    }
  }

  componentDidMount() {
    this.setState({ shouldAnimate: true });
  }

  _hoverHandler = event => {
    this.props.changeTooltipType(this.props.currencyType);
  };

  _toggleTooltip = event => {
    this.props.changeTooltipType(this.props.tooltipType === this.props.currencyType ? null : this.props.currencyType);
  };

  render() {
    const themeContext = this.context;
    return (
      <SCurrencyDisplay
        {...this.props}
        navigation={this.props.navigation}
        value={this.state.value}
        imageOnly={this.props.imageOnly}
        onClick={this.props.onClick}
        toggleTooltip={this._toggleTooltip}
        render={args => {
          const { displayText, rawValue, truncated, onClickHandler, containerHeight, containerWidth } = args;

          const needHover = truncated || this.props.imageOnly;

          return (
            <div
              id={'CurrencyDisplay'}
              className={`CurrencyDisplayWrapper ${this.props.additionalWrapperClassNames}`}
              style={{
                ...styles.containerStyle,
                ...this.props.style,
                ...(this.props.onClick ? { cursor: 'pointer' } : {}),
              }}
              onMouseEnter={needHover ? this._hoverHandler : null}
              onClick={
                typeof onClickHandler === TYPEOF.FUNCTION
                  ? () => (!needHover ? onClickHandler(this.props.currencyType) : null)
                  : onClickHandler
              }
            >
              <CurrencyImageWrapper id="CurrencyBar" className="CurrencyIconWrapper" imageOnly={this.props.imageOnly}>
                {!this.props.imageOnly ? (
                  <Bar
                    barIcon={this.props.source}
                    label={displayText}
                    labelStyle={{
                      ...(this.props.iconType === 'coins'
                        ? themeContext.CurrencyDisplay.CoinsLabel
                        : themeContext.CurrencyDisplay.LoyaltyLabel),
                    }}
                    iconStyle={themeContext.CurrencyDisplay.Icons[this.props.iconType]}
                    animation={
                      !this.props.isCoinsGlowAnimationStopped &&
                      this.props.isCoinsGlowAnimationEnabled &&
                      CoinsGlowAnimation
                    }
                    shineEffect={shineEffectStatus}
                  />
                ) : this.props.ibw ? (
                  <ImageBW
                    source={this.props.source}
                    ibw={this.props.ibw}
                    manualAssetScale={this.props.manualAssetScale || 3}
                    style={{
                      ...styles.currencyImageBWStyle,
                      ...this.props.imgStyle,
                    }}
                  />
                ) : (
                  <img
                    src={this.props.source}
                    style={{
                      ...styles.currencyImageStyle,
                      ...this.props.imgStyle,
                    }}
                    alt=""
                  />
                )}
                <Tooltip
                  source={this.props.source}
                  ibw={this.props.ibw}
                  displayText={rawValue}
                  iconType={this.props.iconType}
                  visible={this.props.tooltipType && this.props.tooltipType === this.props.currencyType}
                  actionHandler={this.props.onClick}
                  style={{
                    height: containerHeight,
                    width: containerWidth,
                    left: this.props.imageOnly ? (50 - containerWidth) / 2 : 'unset',
                  }}
                />
              </CurrencyImageWrapper>
            </div>
          );
        }}
      />
    );
  }
}

CurrencyDisplay.contextType = ThemeContext;

const styles = {
  containerStyle: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: '1rem',
    maxWidth: 230,
  },
  currencyImageStyle: {
    position: 'absolute',
    left: 0,
    top: -2,
    zIndex: 1,
    height: 39,
    width: 32,
    objectFit: 'contain',
  },
  currencyImageBWStyle: {
    position: 'absolute',
    left: 0,
    top: -2,
    zIndex: 1,
    height: 36,
    width: 36,
    objectFit: 'contain',
  },
  currencyBarImage: {
    height: '100%',
    width: '100%',
  },
};

const shineEffectStatus = generateRender({
  default: false,
  ladyluck: true,
});

